import React from 'react'
import { Button, Col, Form, Row, Switch } from 'antd'
import PropTypes from 'prop-types'

import { FormInput } from '../../../common/components/sections'

const MenuDataForm = ({ isLoading, onSubmit }) => {
  const [form] = Form.useForm()

  const handleFinish = values => {
    const { menuUrl, splitByMenuTitle } = values

    const match = menuUrl.match(/\/menu-curation-tasks\/(\d+)/)
    if (match && match[1]) {
      onSubmit(match[1], splitByMenuTitle)
    }
  }

  const urlValidator = (_, value) => {
    if (!value) {
      return Promise.reject(new Error('Please enter a URL'))
    }

    const match = value.match(/\/menu-curation-tasks\/(\d+)/)
    if (!match || !match[1]) {
      return Promise.reject(
        new Error(
          'Invalid URL format. Expected: https://menu-curator.foodstyles.com/menu-curation-tasks/{id}',
        ),
      )
    }

    return Promise.resolve()
  }

  return (
    <Form
      form={form}
      name="menuDataForm"
      onFinish={handleFinish}
      autoComplete="off"
      layout="vertical"
      initialValues={{ splitByMenuTitle: false }}
    >
      <Row gutter={[16]} align="bottom">
        <Col span={12}>
          <FormInput
            name="menuUrl"
            label="Menu Curation Task URL"
            labelAbove
            placeholder="https://menu-curator.foodstyles.com/menu-curation-tasks/any-id"
            rules={[{ validator: urlValidator }]}
          />
        </Col>
        <Col span={6}>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            Submit
          </Button>
        </Col>
      </Row>
      <Row style={{ marginTop: 16 }} align="middle" gutter={[8]}>
        <Col>
          <Form.Item name="splitByMenuTitle" valuePropName="checked" noStyle>
            <Switch />
          </Form.Item>
        </Col>
        <Col>Split by menu title</Col>
      </Row>
    </Form>
  )
}

MenuDataForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
}

MenuDataForm.defaultProps = {
  isLoading: false,
}

export default MenuDataForm
